// extracted by mini-css-extract-plugin
export default {"wrap":"PageContent_wrap__tA42m","content":"PageContent_content__qyVqZ"};